export function removeHtmtFromString(string: string) {
  return string.replace(/<[^>]*>/g, '');
}
